import {Link, StaticQuery, graphql} from 'gatsby';
import React from 'react';

class NavigationLinks extends React.Component {

  constructor(props) {
    super(props);
    this.state = {selectedSection: null};
  }

  toggleSection(evt, section_id) {
    evt.preventDefault();
    const selection = this.state.selectedSection === section_id ? null : section_id;
    this.setState({selectedSection: selection});
  }

  closeMenu(evt) {
    this.setState({selectedSection: null});
  }

  getNodeById(node_id) {
    const edge = this.props.data.allFile.edges.find(edge => {
      return edge.node.name === node_id;
    });
    if (!edge) {
      return null;
    }
    return edge.node.childPagesYaml;
  }

  renderLinkFor(node_id) {
    const lang = this.props.language;
    const node = this.getNodeById(node_id);
    const fields = node ? node[`fields_${lang}`] : {slug: `/${node_id}`, title: node_id};
    return <Link to={fields.slug}>{fields.nav_title || fields.title}</Link>
  }

  render() {
    const lang = this.props.language;

    return (
      <ul>
        <li>
          {this.renderLinkFor('home')}
        </li>
        <li>
          <button onClick={(evt) => this.toggleSection(evt, 'info')}>Info</button>
          <ul data-selected={this.state.selectedSection === 'info'}>
            <li>{this.renderLinkFor('about-me')}</li>
            <li>{this.renderLinkFor('airbrush-make-up')}</li>
            <li>{this.renderLinkFor('professional-photography')}</li>
          </ul>
        </li>
        <li>
          <button onClick={evt => this.toggleSection(evt, 'services')}>
            {lang === 'sl' ? 'Ponudba' : 'Services'}
          </button>
          <ul data-selected={this.state.selectedSection === 'services'} onClick={evt => this.closeMenu(evt)}>
            <li>{this.renderLinkFor('wedding-make-up')}</li>
            <li>{this.renderLinkFor('beauty-make-up')}</li>
            <li>{this.renderLinkFor('advertising-make-up')}</li>
            <li>{this.renderLinkFor('film-make-up')}</li>
            <li>{this.renderLinkFor('fashion-make-up')}</li>
            <li>{this.renderLinkFor('make-up-guidance')}</li>
            <li>{this.renderLinkFor('make-up-tutoring')}</li>
            <li>{this.renderLinkFor('make-up-workshop')}</li>
            <li>{this.renderLinkFor('gift-certificates')}</li>
          </ul>
        </li>
        <li>
          {this.renderLinkFor('pricing')}
        </li>
        <li>
          {this.renderLinkFor('contact')}
        </li>
        <li>
          <a href="https://kanasi.si/collections/porocne-obleke">
            {lang === 'sl' ? 'Poročne obleke' : 'Wedding dresses'}
          </a>
        </li>
      </ul>
    );
  }
}

export default props => (
  <StaticQuery
    query={graphql`
      {
        allFile(filter: {relativeDirectory: {eq: "pages"}}) {
          edges {
            node {
              name
              childPagesYaml {
                fields_sl {
                  slug
                  title
                  nav_title
                }
                fields_en {
                  slug
                  title
                  nav_title
                }
              }
            }
          }
        }
      }
    `}
    render={data => <NavigationLinks data={data} {...props} />}
  />
);
